export const digitalsProductOverImageUrl = 'src/ts/common/assets/digitals-product.png';
export const ornamentsCircleOverImageUrl = 'src/ts/common/assets/ornaments-circle-over-image.png';
export const ornamentsHavenOverImageUrl = 'src/ts/common/assets/ornaments-haven-over-image.png';
export const ornamentsMontereyOverImageUrl =
    'src/ts/common/assets/ornaments-monterey-over-image.png';
export const ornamentsOverImageUrl = 'src/ts/common/assets/ornaments-over-image.png';
